import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DetailCards } from 'components/detail/view/DetailCards';
import { DetailHeader } from 'components/detail/view/DetailHeader';
import styled from 'styled-components/macro';

import { ModalWrapperMini } from 'components/site/modals/ModalWrapperMini';
import { useZoomToMarker } from 'hooks/map/useZoomToMarker';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';

export const DetailModalMini = (): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const { zoomToMarkers } = useZoomToMarker();
    const analytics = useAnalytics();
    const connectedMarkers = ctxModal.detailModal?.detail?.connectedMarkers ?? [];

    const onClose = () => {
        ctxModal.setDetailModal(null);
    };

    const onShowOnMap = () => {
        analytics.track('detail_nav_button.clicked', {
            action: 'zoom_to_marker'
        });

        zoomToMarkers(connectedMarkers);

        ctxModal.closeAll();
    };

    const content =
        ctxModal.detailModal?.id === ctxModal.detailModal?.detail?.storyId ? (
            <S_Content>
                <S_DetailHeader header={ctxModal.detailModal.detail.header} />
                {ctxModal.detailModal.detail.cards?.length > 0 && (
                    <DetailCards cards={ctxModal.detailModal.detail.cards} />
                )}
                {connectedMarkers.length > 0 && (
                    <S_LocateWrapper>
                        <S_LocateButton
                            onClick={onShowOnMap}
                            icon={['far', 'location-crosshairs']}
                        />
                    </S_LocateWrapper>
                )}
            </S_Content>
        ) : (
            <></>
        );

    return <ModalWrapperMini onClose={onClose} content={content} />;
};

const S_Content = styled.div`
    position: relative;
`;

const S_LocateButton = styled(FontAwesomeIcon)`
    font-size: 18px;
    padding: 5px;
    display: flex;
    cursor: pointer;
`;

const S_LocateWrapper = styled.div`
    position: absolute;
    right: 10px;
    top: 10px;
`;

const S_DetailHeader = styled(DetailHeader)`
    padding: 20px 0px 20px 0px;
`;
